import Counter from "@/components/ui/counter";
import useFormattedProductsData from "@/hooks/useFormattedProductsData";
import { IProductListingProps } from "../product-listing";
import { ProductsSection } from ".";
import { HottestLaunchesBanner } from "../../hottest-launches-banner";

const TodaysProducts = ({ todayProptechLaunches }: IProductListingProps) => {
	const formattedTodaysProducts = useFormattedProductsData(todayProptechLaunches || []);

	return (
		<>
			<HottestLaunchesBanner />
			<ProductsSection
				heading={
					<>
						<h2 className="text-xl font-bold text-gray-900 md:text-2xl">
							Today{"'"}s PropTech Launches
						</h2>
						<Counter />
					</>
				}
				products={formattedTodaysProducts}
			/>
		</>
	);
};

export default TodaysProducts;
